import ActiveConsents from './ActiveConsents'

export default ActiveConsents
